interface BlockExportRow {
  date: string;
  shiftStart: string;
  shiftEnd: string;
  basePay: number;
  tip: number;
  noRoutePayout: number;
  totalEarnings: number;
  station: string;
  notes: string;
  mileage: number | null;
  mileageSource: string;
}

export function generateCSV(blocks: BlockExportRow[]): string {
  const headers = [
    "Date",
    "Start Time",
    "End Time",
    "Base Pay ($)",
    "Tip ($)",
    "No-Route ($)",
    "Total ($)",
    "Station",
    "Mileage",
    "Mileage Source",
    "Notes",
  ];

  const rows = blocks.map((block) => [
    block.date,
    block.shiftStart,
    block.shiftEnd,
    block.basePay.toFixed(2),
    block.tip.toFixed(2),
    block.noRoutePayout.toFixed(2),
    block.totalEarnings.toFixed(2),
    escapeCSV(block.station),
    block.mileage?.toFixed(1) ?? "",
    block.mileageSource,
    escapeCSV(block.notes),
  ]);

  const csvContent = [
    headers.join(","),
    ...rows.map((row) => row.join(",")),
  ].join("\n");

  return csvContent;
}

function escapeCSV(value: string): string {
  if (!value) return "";
  // Escape quotes and wrap in quotes if contains comma, quote, or newline
  if (value.includes(",") || value.includes('"') || value.includes("\n")) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function downloadCSV(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
